import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithStreams,
} from 'widgets/WidgetRegistry';
import { WidgetType } from '../WidgetType';
import { ExpertiseReportType } from 'communication/types/expertise/ExpertiseReportType';
import { expertiseNighthawkWidgetStrategy } from './expertiseNighthawk/ExpertiseNighthawkWidgetStrategy';
import { expertiseMakeWidgetStrategy } from './expertiseMake/ExpertiseMakeWidgetStrategy';
import { ColDef } from 'ag-grid-community';
import { IndigoAppContextType } from 'app/AppContext';
import { ExpertiseConfigurationState } from './store/configuration/ExpertiseConfigurationState';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { expertiseDnaWidgetStrategy } from 'widgets/expertise/expertiseDna/ExpertiseDnaWidgetStrategy.ts';

export type ExpertiseWidgetType =
    | WidgetType.EXPERTISE_MAKE
    | WidgetType.EXPERTISE_NIGHTHAWK
    | WidgetType.EXPERTISE_DNA;

export interface ExpertiseWidgetStrategy
    extends WidgetStrategyWithConfig<ExpertiseConfigurationState>,
        WidgetStrategyWithStreams {
    reportType: ExpertiseReportType;
    buildColumnDefs: (context: IndigoAppContextType) => ColDef[];
    portfolioSelectionRequirements: PortfolioSelectionRequirements;
}

export function getExpertiseWidgetStrategy(expertiseWidgetType: WidgetType) {
    switch (expertiseWidgetType) {
        case WidgetType.EXPERTISE_MAKE:
            return expertiseMakeWidgetStrategy;
        case WidgetType.EXPERTISE_NIGHTHAWK:
            return expertiseNighthawkWidgetStrategy;
        case WidgetType.EXPERTISE_DNA:
            return expertiseDnaWidgetStrategy;
        default:
            throw new Error(
                `"${expertiseWidgetType}" is not an Expertise widget type`
            );
    }
}
